/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
  SET_YOUR_PASSWORD_ROUTE_NAME,
  SUCCESSFULLY_VERIFIED_ROUTE_NAME,
  VERIFY_YOUR_ACCOUNT_ROUTE_NAME
} from './account-activation/models';
import { CredentialsGuard, NavigationGuard, VerifyAccountRequestGuard } from './shared/guards';

export const routes: Routes = [
  {
    path: SET_YOUR_PASSWORD_ROUTE_NAME,
    canActivate: [NavigationGuard],
    pathMatch: 'full',
    loadChildren: () =>
      import('./account-activation/containers/set-your-password/set-your-password.module').then(module => module.SetYourPasswordModule)
  },
  {
    path: VERIFY_YOUR_ACCOUNT_ROUTE_NAME,
    canActivate: [CredentialsGuard],
    pathMatch: 'full',
    loadChildren: () =>
      import('./account-activation/containers/verify-your-account/verify-your-account.module').then(
        module => module.VerifyYourAccountModule
      )
  },
  {
    path: SUCCESSFULLY_VERIFIED_ROUTE_NAME,
    canActivate: [VerifyAccountRequestGuard],
    pathMatch: 'full',
    loadChildren: () =>
      import('./account-activation/containers/successfully-verified/successfully-verified.module').then(
        module => module.SuccessfullyVerifiedModule
      )
  },
  {
    path: '**',
    redirectTo: SET_YOUR_PASSWORD_ROUTE_NAME,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      initialNavigation: 'enabledNonBlocking'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
